import { createSlice } from "@reduxjs/toolkit";

export const parcSlice = createSlice({
  name: "parc",
  initialState: {
    withoutVehicle: 0,
    estimateDepositAlert: 0,
    estimateDepositBookings: [],
  },
  reducers: {
    pushData: (state, action) => {
      if (action.payload.booking !== undefined) {
        state.withoutVehicle = action.payload.booking;
      }
      if (action.payload.estimateDepositAlert !== undefined) {
        state.estimateDepositAlert = action.payload.estimateDepositAlert;
      }
      if (action.payload.estimateDepositBookings !== undefined) {
        state.estimateDepositBookings = action.payload.estimateDepositBookings;
      }
    },
  },
});

export const { pushData } = parcSlice.actions;

export default parcSlice.reducer;
